import script from "./GeminiChatbot.vue?vue&type=script&setup=true&lang=js"
export * from "./GeminiChatbot.vue?vue&type=script&setup=true&lang=js"

import "./GeminiChatbot.vue?vue&type=style&index=0&id=35849468&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35849468"]])

export default __exports__